/**
 * Singleton de inicialização do pdfjs-dist.
 * Garante que o worker seja configurado uma única vez,
 * usando URL versionada do CDN para evitar mismatch.
 */
import * as pdfjsLib from 'pdfjs-dist';

let initialized = false;

export function getPdfjsLib() {
  if (!initialized) {
    pdfjsLib.GlobalWorkerOptions.workerSrc =
      `https://unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.mjs`;
    initialized = true;
  }
  return pdfjsLib;
}
